import { lazy } from "react"

const HistoryPage$$__react__lazy__component = lazy(() => 
    import("./HistoryPage__original__module.mjs")
        .then(module => module.get_$$HistoryPage$$HistoryPage$$react__component$$3lqkww3xcegyr())
        .then(component => ({ default: component }))
)

export const get_$$HistoryPage$$HistoryPage$$react__component$$3lqkww3xcegyr = () => HistoryPage$$__react__lazy__component